import React from 'react';
import styled from 'styled-components';
import { mediaMSmMax } from 'helpers/breakpoints';
import boatsetterPaths from 'utils/boatsetterPaths';
import getConfig from 'next/config';
import AccountSettingsNav, { ActiveNavOption } from './AccountSettingsLayoutNav';

const Wrapper = styled.div`
  margin: 64px 0;
  ${mediaMSmMax} {
    margin-top: 20px;
  }

  .container {
    max-width: 960px;
    padding: 0 16px;
    margin: auto;
    ${mediaMSmMax} {
      padding: 0 22px;
    }
  }

  h2 {
    font-weight: bold;
    font-size: 21px;
    line-height: 29px;
    ${mediaMSmMax} {
      font-size: 18px;
      line-height: 28px;
    }
  }
`;

const Header = styled.div`
  .back {
    display: none;
    ${mediaMSmMax} {
      display: flex;
      cursor: pointer;
      padding-bottom: 25px;
    }
    svg {
      margin: auto 0;
    }
    a {
      color: #0751c2;
      font-weight: 500;
      font-size: 16px;
      margin-left: 10px;
      text-decoration: none;
    }
  }

  h1 {
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    margin-bottom: 32px;
    ${mediaMSmMax} {
      display: none;
    }
  }
`;

const LayoutWrapper = styled.div`
  display: flex;

  .content {
    padding-left: 48px;
    ${mediaMSmMax} {
      padding-left: 0;
    }

    width: 75%;

    &.loading {
      display: flex;
      width: 100%;
      span {
        margin: auto;
      }
    }

    ${mediaMSmMax} {
      padding-left: 0;
    }
  }
`;

interface AccountSettingsLayoutProps {
  children: React.ReactNode;
  activeNav?: ActiveNavOption;
  isLoading?: boolean;
}

const { BYPASS_CLERK } = getConfig().publicRuntimeConfig;

const AccountSettingsLayout: React.FC<AccountSettingsLayoutProps> = ({
  children,
  activeNav = 'notifications', // default active nav item
  isLoading,
}) => (
  <Wrapper style={{ paddingTop: '60px' }}>
    <div className="layout">
      <div className="container">
        <Header>
          <div className="back">
            <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 7.87L7.66 15.53C7.95 15.82 8.43 15.82 8.72 15.53C9.01 15.24 9.01 14.76 8.72 14.47L2.12 7.87L8.72 1.27C9.01 0.98 9.01 0.5 8.72 0.21C8.43 -0.08 7.95 -0.08 7.66 0.21L0 7.87Z"
                fill="#0751C2"
              />
            </svg>
            <a href={boatsetterPaths.account}>My account</a>
          </div>
          <h1>My account</h1>
        </Header>
        <LayoutWrapper>
          <AccountSettingsNav active={activeNav} bypassClerk={BYPASS_CLERK} />
          <div className={`content ${isLoading && 'loading'}`}>{children}</div>
        </LayoutWrapper>
      </div>
    </div>
  </Wrapper>
);
export default AccountSettingsLayout;
